import React, { FunctionComponent, ReactNode } from 'react';

import { FooterSection } from '@gojob/cms';
import FooterLink from '@gojob/ui-bits/Footer/Link';
import BaseFooterSection from '@gojob/ui-bits/Footer/Section';

import Link from '../Link';

interface SectionProps extends FooterSection {
  children?: ReactNode;
}

const Section = (props: SectionProps) => {
  const { links, children } = props;

  return (
    <BaseFooterSection>
      {links?.map((link, index) => {
        const { href, id, internalRef, text } = link;
        const to = internalRef?.slug?.current;

        return (
          <FooterLink key={index} as={Link} id={id} href={href} to={to}>
            {text}
          </FooterLink>
        );
      })}

      {children}
    </BaseFooterSection>
  );
};

export default Section;
